import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "column text-body1" }
const _hoisted_2 = {
  key: 0,
  class: "text-body1 description"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "sfx-toggle__label" }

import { computed } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxToggleSettings',
  props: {
  // Accepts any types
  modelValue: {
    required: true,
  },

  description: {
    type: String,
  },

  trinary: {
    type: Boolean,
    default: false,
  },

  html: {
    type: Boolean,
    default: false,
  },

  trueValue: { type: [String, Number, Boolean], default: true },

  trueLabel: String,

  falseValue: { type: [String, Number, Boolean], default: false },

  falseLabel: String,

  indeterminateValue: { type: [String, Number, Boolean], default: null },

  // Note! When the default state of the trinary toggle must be its indeterminate state
  // and the `indeterminateLabel` prop is used, then `indeterminateValue` cannot be set to `undefined`,
  // because if so, the label is not showing by default.
  indeterminateLabel: String,

  hideToggle: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const model = computed({
  get() {
    return props.modelValue
  },

  set(value) {
    return emit("update:modelValue", value)
  },
})

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, { class: "sfx-toggle items-center" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (props.description)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              (props.html)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    innerHTML: props.description
                  }, null, 8, _hoisted_3))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(props.description), 1))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_5, [
          (props.trueLabel && model.value === props.trueValue)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(props.trueLabel), 1)
              ], 64))
            : (
            props.trinary && props.indeterminateLabel && model.value === props.indeterminateValue
          )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(props.indeterminateLabel), 1)
                ], 64))
              : (props.falseLabel && model.value === props.falseValue)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(props.falseLabel), 1)
                  ], 64))
                : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_q_space),
      (!props.hideToggle)
        ? (_openBlock(), _createBlock(_component_q_toggle, _mergeProps({
            key: 0,
            modelValue: model.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
            "toggle-indeterminate": props.trinary,
            "true-value": props.trueValue,
            "false-value": props.falseValue,
            "indeterminate-value": props.indeterminateValue
          }, _ctx.$attrs), null, 16, ["modelValue", "toggle-indeterminate", "true-value", "false-value", "indeterminate-value"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})